import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = ['admin', 'manager', 'staff'] }) => {
  const { user, userProfile, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Verifying access...</p>
        </div>
      </div>
    );
  }

  // Redirect to admin login if not authenticated
  if (!user) {
    return <Navigate to="/admin-login" replace />;
  }

  // Redirect to admin login if user profile not loaded or role not allowed
  if (!userProfile || !allowedRoles?.includes(userProfile?.role)) {
    return <Navigate to="/admin-login" replace />;
  }

  // User is authenticated and has proper role
  return children;
};

export default ProtectedRoute;